import React, { useEffect } from "react";
import benchStore from "./store";

interface IProps {
  id: number;
}
function Item(props: IProps) {
  const { count } = benchStore.useState("count");
  return (
    <div>
      {props.id}, FunctionComponent, {count}
    </div>
  );
}

class ClassItem extends React.Component<IProps> {
  s = benchStore.classUseState(this, "count");
  render() {
    return (
      <div>
        {this.props.id}, ClassComponent, {this.s.count}
      </div>
    );
  }
}

function setNum(n: number) {
  benchStore.setState({
    num: n
  });
}

function setType(e: React.MouseEvent<HTMLInputElement>) {
  benchStore.setState({
    type: e.currentTarget.value
  });
}

function toggleDisplay(e: any) {
  benchStore.setState((s) => ({ display: !s.display }));
}

export default function Benchmark() {
  const { num, fps, type, display } = benchStore.useState(
    "num",
    "fps",
    "type",
    "display"
  );
  useEffect(() => {
    setNum(100);
  }, []);
  let Child;
  if (type === "fc") {
    Child = Item;
  } else {
    Child = ClassItem;
  }
  const list = [];
  for (let n = 0; n < num; n++) {
    list.push(<Child key={n} id={n} />);
  }
  return (
    <div>
      <label>
        <input
          name="component"
          checked={type === "fc"}
          onClick={setType}
          type="radio"
          value="fc"
        />{" "}
        FunctionComponent
      </label>
      <label>
        <input
          name="component"
          checked={type === "cc"}
          onClick={setType}
          type="radio"
          value="cc"
        />{" "}
        ClassComponent
      </label>
      <div>{num} Components</div>
      <button onClick={() => setNum(100)}>100</button>
      <button onClick={() => setNum(500)}>500</button>
      <button onClick={() => setNum(1000)}>1000</button>
      <button onClick={() => setNum(5000)}>5000</button>
      <button onClick={() => setNum(10000)}>10000</button>
      <label>
        <input checked={display} type="checkbox" onChange={toggleDisplay} />{" "}
        Display Nodes
      </label>
      <div>FPS {fps}</div>
      <div style={{ display: display ? "block" : "none" }}>{list}</div>
    </div>
  );
}
